export default "__VITE_ASSET__BsdPuL6V__"